/*
 * B2B-only: attach the selected variant's SKU as a visible line-item
 * property ("SKU: ...") on add-to-cart, so Shopify checkout displays it
 * under each line. Gated by body.pj-b2b (set server-side in theme.liquid),
 * so D2C carts and checkouts are untouched.
 *
 * The SKU value is read from the PDP SKU block (.product__sku), which
 * product-info.js keeps in sync with the selected variant. Forms outside a
 * product-info wrapper (simple quick-adds, gift-wrap buttons) have no SKU
 * block in scope and are deliberately left alone.
 *
 * Capture phase so the input exists before product-form.js builds FormData.
 */
document.addEventListener(
  'submit',
  (event) => {
    if (!document.body.classList.contains('pj-b2b')) return;

    const form = event.target;
    if (!form.matches('form[action*="/cart/add"]')) return;

    const scope = form.closest('product-info, quick-add-modal');
    if (!scope) return;

    const skuEl = scope.querySelector('.product__sku');
    if (!skuEl) return;

    const clone = skuEl.cloneNode(true);
    clone.querySelectorAll('.visually-hidden').forEach((n) => n.remove());
    const sku = clone.textContent.trim();
    if (!sku) return;

    let input = form.querySelector('input[name="properties[SKU]"]');
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'properties[SKU]';
      form.appendChild(input);
    }
    input.value = sku;
  },
  true
);
